import { useGamesList } from './api'

/** What is going on at the tables, for a badge: open tables to join, and moves waiting for you. */
export function useGamesSummary(me: string) {
  const list = useGamesList(false)
  const tables = list.data?.tables ?? []
  const live = tables.filter((t) => t.status === 'lobby' || t.status === 'playing')
  return {
    tables: live,
    open: live.filter((t) => t.status === 'lobby' && t.players.length < t.max && !t.players.includes(me)).length,
    waiting: live.filter((t) => t.myTurn).length,
    playing: live.filter((t) => t.status === 'playing').length,
  }
}
